// Packages
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import InlineEdit from 'components/SharedComponents/Inline/inline-edit';

// Helpers
import { dragulaDecorator } from 'app-lib/helpers/drag-and-drop-helper';

const classPrefix = 'content-area';
const breakPoints = [640, 850, 1060, 1250, 1560, 1870, 10000];

export class ContentArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    expandContents() {
        this.state.expanded ? this.setState({expanded: false}) : this.setState({expanded: true});
    }

    getContentLimitNumber() {
        let contentLimit = 12;
        const screenSize = window.innerWidth;
        if (screenSize < breakPoints[0]) {
            contentLimit = 4;
        } else if (screenSize >= breakPoints[0] && screenSize < breakPoints[1]) {
            contentLimit = 6;
        } else if (screenSize >= breakPoints[1] && screenSize < breakPoints[2]) {
            contentLimit = 8;
        } else if (screenSize >= breakPoints[2] && screenSize < breakPoints[3]) {
            contentLimit = 10;
        } else if (screenSize >= breakPoints[3] && screenSize < breakPoints[4]) {
            contentLimit = 8;
        } else if (screenSize >= breakPoints[4] && screenSize < breakPoints[5]) {
            contentLimit = 12;
        }
        return contentLimit;
    }

    showAllContents() {
        const limitedContents = this.props.details.slice(0, this.getContentLimitNumber());
        if (this.state.expanded) {
            return this.props.details;
        }
        return limitedContents;
    }

    titleInlineEdit() {
        const {t, title, groupKey, isChannelOwner, isDefaultGroup} = this.props;
        if (isDefaultGroup) {
            return null;
        }
        return (
        (isChannelOwner) ?
            <span className="channel-group_title" >
                <InlineEdit
                  maxlength={50}
                  t={t}
                  editText={this.dataChanged.bind(this, groupKey)}
                  text={title}
                  id={groupKey}
                  characterCheckRequired={true}
                />
            </span>
          : <div className={`${classPrefix}-title`}>{title}</div>
        );
    }

    dataChanged(groupKey, id, data) {
        this.props.groupNameChanged(groupKey, id, data);
    }

    handleMoveGroup(moveType) {
        this.props.moveGroup(this.props.groupKey, moveType);
    }

    moveGroupUpDownButtons() {
        const {isChannelOwner, isDefaultGroup, allGroupKeys} = this.props;
        return (
            (isChannelOwner && !isDefaultGroup && (allGroupKeys.length !== 1)) ?
                <div className="text-right">
                    <div className="content-area__move-button">
                        <span className="content-area__move-up" onClick={this.handleMoveGroup.bind(this, -1)}><i className="togo-icon togo-icon-arrow-right togo-icon-rotate-270"></i></span>
                        <span className="content-area__move-down" onClick={this.handleMoveGroup.bind(this, 1)}><i className="togo-icon togo-icon-arrow-right togo-icon-rotate-90"></i></span>
                    </div>
                </div> : null
        );
    }

    viewMoreLessBtn() {
        if (this.props.details.length > this.getContentLimitNumber()) {
            const {t} = this.props;
            const viewMore = <span>{t('channel.content-area.view-more-btn')}<i className="togo-icon togo-icon-down-arrow togo-icon-lg"></i></span>;
            const viewLess = <span>{t('channel.content-area.view-less-btn')}<i className="togo-icon togo-icon-down-arrow togo-icon-flip-vertical togo-icon-lg"></i></span>;
            return (this.state.expanded) ? viewLess : viewMore;
        }
        return null;
    }
    render() {
        return (
            <div className={`${classPrefix}-container`}>
                <div className={`${classPrefix}`}>
                    <div className={`${classPrefix}-headers`}>
                    {this.titleInlineEdit()}
                    {this.moveGroupUpDownButtons()}
                    </div>
                    <div id={this.props.groupKey} className={`${classPrefix}-wrapper`} ref={dragulaDecorator.bind(this)}>
                        {this.showAllContents()}
                    </div>
                    <div className="text-right">
                        <div className={`${classPrefix}-view-btn`} onClick={this.expandContents.bind(this)}>{this.viewMoreLessBtn()}</div>
                    </div>
                </div>
            </div>
        );
    }
}

ContentArea.propTypes = {
    t: PropTypes.func,
    groupKey: PropTypes.string,
    isChannelOwner: PropTypes.bool,
    title: PropTypes.string,
    details: PropTypes.array,
    groupNameChanged: PropTypes.func,
    isDefaultGroup: PropTypes.bool,
    moveGroup: PropTypes.func,
    dragulaInstance: PropTypes.object,
    allGroupKeys: PropTypes.array
};

export default (translate(['translation'])(ContentArea));



// WEBPACK FOOTER //
// ./src/components/catalog/content-area/content-area.js